module.exports = __webpack_public_path__ + "img/card-image1@2x.8484b440.png";